import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/sweep/cutoff/_cutoff')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sweep-cutoff',
        label: 'Sweeps',
        to: '/sweep/cut-off',
      }),
    }) satisfies AggregateBreadcrumb,
});
